import { useDistributions } from '~hooks/useDistributions'

export function useIsCampaignOnboardingDisabled(campaignId: string) {
  const { distributions } = useDistributions(campaignId, 1)

  return distributions.length > 0
}
